import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Grid,
    InputAdornment,
    MenuItem,
    TextField,
    Tooltip,
    Typography,
    withStyles,
} from "@material-ui/core";
import { green, red } from "@material-ui/core/colors";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloseIcon from "@material-ui/icons/Close";
import DateIconProv from "../utils/DateIconProv";
import { DatePicker } from "@material-ui/pickers";
import DoneIcon from "@material-ui/icons/Done";
import ErrorIcon from "@material-ui/icons/Error";
import { Fragment } from "react";
import { IconButton } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import ProveedoresTitle from "../layout/ProveedoresTitle";
import { enumMaxWidth } from "../../settings/enumConfig";
import { imgEjemploConstancia } from "../../settings/imgConfig";
import { useCobertura } from "../../context/CoberturaContext";
import { useDatosCompania } from "../../context/DatosCompaniaContext";
import { useDomicioFiscal } from "../../context/DomicilioFiscalContext";
import { useEffect } from "react";
import { useProveedoresProspectos } from "../../context/ProveedoresProspectosContext";
import { useTipoPersona } from "../../context/TipoPersonaContext";

const ImgToolTip = withStyles((theme) => ({
    tooltip: {
        maxWidth: 400,
    },
}))(Tooltip);

const DatosCompania = () => {
    const { listaTipoPersona } = useTipoPersona();
    const { listaCobertura } = useCobertura();
    const { entSolicitudDetalleForEdit } = useProveedoresProspectos();
    const { handleChangLoadEvalPais } = useDomicioFiscal();
    const {
        datosCompaniaForm,
        cartaPresentacionArhivo,
        constanciaSituacionFiscal,
        rfcValido,
        rfcValidaMensaje,
        handleClickDeleteChipCobertura,
        handleClickEliminarArchivoCartaPresentacion,
        handleClickEliminarArchivoSituacionFiscal,
        handleChangeDatosCompaniaText,
        handleChangeDatosCompaniaDate,
        handleChangeDatosCompaniaUInt,
        handleChangeDatosCompaniaUpper,
        handleChangeDatosCompaniaNotError,
        handleChangeDatosCompaniaTextRFC,
        handleClickConfirmarDatosCompania,
        handleClickAdjuntarCartaPresentacion,
        handleClickAdjuntarConstanciaSituacionFiscal,
        handleBlurValidaRFC,
    } = useDatosCompania();

    const {
        txtTipoPersona,
        txtNombreContactoPrincipal,
        txtRFC,
        txtTelefonoContactoPrincipal,
        txtRazonSocial,
        txtCorreoContactoPrincipal,
        txtCobertura,
        txtNumeroDUNS,
        txtNumeroEmpleados,
        txtRegistroPatronalIMSS,
        txtFechaConstitucionEmpresa,
        txtCartaPresentacion,
        txtSituacionFiscal,
        txtSitioWeb,
        txtNombreComercial,
    } = datosCompaniaForm;

    useEffect(() => {
        handleChangLoadEvalPais();
        // eslint-disable-next-line
    }, [datosCompaniaForm]);

    return (
        <Fragment>
            <Grid container spacing={4} className="content-over">
                <Grid item xs={12}>
                    <Box style={{ borderRadius: "15px", maxWidth: enumMaxWidth, margin: "auto" }}>
                        <Grid container spacing={4}>
                            {listaTipoPersona.length === 0 || listaCobertura.length === 0 ? (
                                <Grid item xs={12} className="center">
                                    <CircularProgress />
                                    <Typography>Cargando formulario...</Typography>
                                </Grid>
                            ) : (
                                <Fragment>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Información de la compañía</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2">
                                            Capture los siguientes datos para completar su solicitud de proveedor de Bepensa
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtTipoPersona.name}
                                                    label={txtTipoPersona.label}
                                                    required={txtTipoPersona.required}
                                                    value={txtTipoPersona.value}
                                                    error={txtTipoPersona.required && txtTipoPersona.error}
                                                    helperText={txtTipoPersona.required && txtTipoPersona.error && txtTipoPersona.helper}
                                                    onChange={handleChangeDatosCompaniaText}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    select
                                                    disabled={!!entSolicitudDetalleForEdit}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            getContentAnchorEl: null,
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="">-- Seleccione tipo de persona</MenuItem>
                                                    {listaTipoPersona.map((x) => (
                                                        <MenuItem key={x.iIdTipoPersona} value={x.iIdTipoPersona.toString()}>
                                                            {x.sDescripcion}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    className="input-upper"
                                                    name={txtRFC.name}
                                                    label={txtTipoPersona.value > 1000 ? txtRFC.label2 : txtRFC.label}
                                                    required={txtRFC.required}
                                                    value={txtRFC.value}
                                                    error={(txtRFC.required && txtRFC.error) || !!rfcValidaMensaje}
                                                    helperText={
                                                        // txtRFC.required && txtRFC.error
                                                        //     ? txtRFC.helper
                                                        //     : !!rfcValidaMensaje
                                                        //     ? rfcValidaMensaje
                                                        //     : null
                                                        !!rfcValidaMensaje
                                                            ? rfcValidaMensaje
                                                            : txtRFC.required && txtRFC.error
                                                            ? txtTipoPersona.value > 1000
                                                                ? txtRFC.helper2
                                                                : txtRFC.helper
                                                            : null
                                                    }
                                                    onChange={handleChangeDatosCompaniaTextRFC}
                                                    onBlur={handleBlurValidaRFC}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    disabled={!!entSolicitudDetalleForEdit}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: txtTipoPersona.value > 1000 ? 18 : 13,
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {rfcValido !== null &&
                                                                    (rfcValido ? (
                                                                        // <Tooltip
                                                                        //     title="El RFC puede realizar la solicitud de proveedor prospecto"
                                                                        //     placement="top"
                                                                        //     arrow
                                                                        // >
                                                                        <DoneIcon style={{ color: green[500] }} />
                                                                    ) : (
                                                                        // </Tooltip>
                                                                        // <Tooltip
                                                                        //     title="El RFC ya cuenta con una solicitud de proveedor prospecto"
                                                                        //     placement="top"
                                                                        //     arrow
                                                                        // >
                                                                        <ErrorIcon style={{ color: red[500] }} />
                                                                        // </Tooltip>
                                                                    ))}
                                                                <Tooltip
                                                                    title={
                                                                        txtTipoPersona.value > 1000
                                                                            ? "Número de registro fiscal/TAX ID"
                                                                            : "Registro Federal de Contribuyentes"
                                                                    }
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <IconButton>
                                                                        <InfoIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            {(txtTipoPersona.value === "2" || txtTipoPersona.value === "1002") && (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        className="input-upper"
                                                        name={txtRazonSocial.name}
                                                        label={txtRazonSocial.label}
                                                        required={txtRazonSocial.required}
                                                        value={txtRazonSocial.value}
                                                        error={txtRazonSocial.required && txtRazonSocial.error}
                                                        helperText={
                                                            txtRazonSocial.required && txtRazonSocial.error && txtRazonSocial.helper
                                                        }
                                                        onChange={handleChangeDatosCompaniaUpper}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 300,
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title={`Debe de agregarse la estructura legal de la compañía como "SA de CV", SA de CV de SRL", "SC", etc`}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <IconButton>
                                                                            <InfoIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                {/* <FormControl fullWidth variant={inputVariant} color={inputColor}>
                                                    <InputLabel htmlFor={txtCobertura.name}>{txtCobertura.label}</InputLabel>
                                                    <Select
                                                        // labelId={txtCobertura.name}
                                                        required={txtCobertura.required}
                                                        multiple
                                                        label={txtCobertura.label}
                                                        value={txtCobertura.value}
                                                        error={txtCobertura.required && txtCobertura.error}
                                                        helperText={txtCobertura.required && txtCobertura.error && txtCobertura.helper}
                                                        onChange={handleChangeDatosCompaniaText}
                                                        inputProps={{
                                                            name: txtCobertura.name,
                                                            id: txtCobertura.name,
                                                        }}
                                                        // defaultValue={defaultCoberturaValues}
                                                        // renderValue={(selected) => (
                                                        //     <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                        //         {selected.map((value) => (
                                                        //             <Chip
                                                        //                 key={value.iIdCobertura}
                                                        //                 label={value.sDescripcion}
                                                        //                 style={{ marginRight: 10, marginBottom: 5 }}
                                                        //                 color="primary"
                                                        //                 onDelete={() => handleClickDeleteChipCobertura(value)}
                                                        //                 deleteIcon={<CloseIcon />}
                                                        //                 onMouseDown={(event) => {
                                                        //                     event.stopPropagation();
                                                        //                 }}
                                                        //             />
                                                        //         ))}
                                                        //     </div>
                                                        // )}
                                                    >
                                                        {listaCobertura.map((x) => (
                                                            <MenuItem key={x.iIdCobertura} value={x}>
                                                                {x.sDescripcion}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl> */}
                                                <TextField
                                                    name={txtCobertura.name}
                                                    label={txtCobertura.label}
                                                    required={txtCobertura.required}
                                                    value={txtCobertura.value}
                                                    error={txtCobertura.required && txtCobertura.error}
                                                    helperText={txtCobertura.required && txtCobertura.error && txtCobertura.helper}
                                                    onChange={handleChangeDatosCompaniaText}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    select
                                                    multiline
                                                    SelectProps={{
                                                        multiple: true,
                                                        renderValue: (selected) => (
                                                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                                {selected.map((value) => (
                                                                    <Chip
                                                                        key={value.iIdCobertura}
                                                                        label={value.sDescripcion}
                                                                        style={{ marginRight: 10, marginBottom: 5 }}
                                                                        color="primary"
                                                                        onDelete={() => handleClickDeleteChipCobertura(value)}
                                                                        deleteIcon={<CloseIcon />}
                                                                        onMouseDown={(event) => {
                                                                            event.stopPropagation();
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        ),
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            getContentAnchorEl: null,
                                                        },
                                                    }}
                                                >
                                                    {listaCobertura.map((x) => (
                                                        <MenuItem key={x.iIdCobertura} value={x}>
                                                            {x.sDescripcion}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <DatePicker
                                                    name={txtFechaConstitucionEmpresa.name}
                                                    label={txtFechaConstitucionEmpresa.label}
                                                    required={txtFechaConstitucionEmpresa.required}
                                                    value={txtFechaConstitucionEmpresa.value}
                                                    error={txtRegistroPatronalIMSS.required && txtRegistroPatronalIMSS.error}
                                                    helperText={
                                                        txtRegistroPatronalIMSS.required &&
                                                        txtRegistroPatronalIMSS.error &&
                                                        txtRegistroPatronalIMSS.helper
                                                    }
                                                    onChange={(date) =>
                                                        handleChangeDatosCompaniaDate(date, txtFechaConstitucionEmpresa.name)
                                                    }
                                                    InputProps={{
                                                        endAdornment: (
                                                            <Fragment>
                                                                <DateIconProv />
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title="Fecha en la que se dio de alta a la empresa ante su entidad tributaria, es requerido que tenga mínimo dos años de haberse constituido"
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <IconButton>
                                                                            <InfoIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            </Fragment>
                                                        ),
                                                    }}
                                                    views={["year", "month", "date"]}
                                                    inputVariant={inputVariant}
                                                    cancelLabel="Cancelar"
                                                    okLabel="Aceptar"
                                                    format="dd/MM/yyyy"
                                                    color={inputColor}
                                                    maxDate={new Date().setFullYear(new Date().getFullYear() - 2)}
                                                    variant="dialog"
                                                    openTo="date"
                                                    autoOk={true}
                                                    disableFuture
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtSituacionFiscal.name}
                                                    label={txtSituacionFiscal.label}
                                                    required={txtSituacionFiscal.required}
                                                    value={txtSituacionFiscal.value}
                                                    error={txtSituacionFiscal.required && txtSituacionFiscal.error}
                                                    helperText={
                                                        txtSituacionFiscal.required && txtSituacionFiscal.error && txtSituacionFiscal.helper
                                                    }
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 11,
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {constanciaSituacionFiscal && (
                                                                    <IconButton onClick={handleClickEliminarArchivoSituacionFiscal}>
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                )}
                                                                <IconButton onClick={handleClickAdjuntarConstanciaSituacionFiscal}>
                                                                    <AttachFileIcon />
                                                                </IconButton>
                                                                {txtTipoPersona.value > 1000 ? (
                                                                    <Tooltip
                                                                        title="Proporcionar un documento que contiene información del registro fiscal/TAX ID emitido por la institución tributaria de su país"
                                                                        arrow
                                                                        placement="top"
                                                                    >
                                                                        <IconButton>
                                                                            <InfoIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <ImgToolTip
                                                                        title={
                                                                            <div>
                                                                                <div>
                                                                                    Proporcionar un documento que contiene información del
                                                                                    Registro Federal de Contribuyentes y la Cédula de
                                                                                    Identificación Fiscal. Dicho documento debe de estar
                                                                                    expedido con no más de 60 días. Imagen de ejemplo:
                                                                                </div>
                                                                                <div>
                                                                                    <img
                                                                                        src={imgEjemploConstancia}
                                                                                        alt="Ejemplo constancia"
                                                                                        style={{ width: "100%" }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        placement="right"
                                                                        arrow
                                                                    >
                                                                        <IconButton>
                                                                            <InfoIcon />
                                                                        </IconButton>
                                                                    </ImgToolTip>
                                                                )}
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            {(txtTipoPersona.value === "2" || txtTipoPersona.value === "1002") && (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        name={txtNumeroEmpleados.name}
                                                        label={txtNumeroEmpleados.label}
                                                        required={txtNumeroEmpleados.required}
                                                        value={txtNumeroEmpleados.value}
                                                        error={txtNumeroEmpleados.required && txtNumeroEmpleados.error}
                                                        helperText={
                                                            txtNumeroEmpleados.required &&
                                                            txtNumeroEmpleados.error &&
                                                            txtNumeroEmpleados.helper
                                                        }
                                                        onChange={handleChangeDatosCompaniaUInt}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 10,
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                            {(txtTipoPersona.value === "1" || txtTipoPersona.value === "1001") && (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        name={txtNombreComercial.name}
                                                        label={txtNombreComercial.label}
                                                        required={txtNombreComercial.required}
                                                        value={txtNombreComercial.value}
                                                        error={txtNombreComercial.required && txtNombreComercial.error}
                                                        helperText={
                                                            txtNombreComercial.required &&
                                                            txtNombreComercial.error &&
                                                            txtNombreComercial.helper
                                                        }
                                                        onChange={handleChangeDatosCompaniaText}
                                                        variant={inputVariant}
                                                        color={inputColor}
                                                        fullWidth
                                                        inputProps={{
                                                            maxLength: 300,
                                                        }}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container spacing={4}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtNombreContactoPrincipal.name}
                                                    label={txtNombreContactoPrincipal.label}
                                                    required={txtNombreContactoPrincipal.required}
                                                    value={txtNombreContactoPrincipal.value}
                                                    error={txtNombreContactoPrincipal.required && txtNombreContactoPrincipal.error}
                                                    helperText={
                                                        txtNombreContactoPrincipal.required &&
                                                        txtNombreContactoPrincipal.error &&
                                                        txtNombreContactoPrincipal.helper
                                                    }
                                                    onChange={handleChangeDatosCompaniaText}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 200,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtTelefonoContactoPrincipal.name}
                                                    label={txtTelefonoContactoPrincipal.label}
                                                    required={txtTelefonoContactoPrincipal.required}
                                                    value={txtTelefonoContactoPrincipal.value}
                                                    error={txtTelefonoContactoPrincipal.required && txtTelefonoContactoPrincipal.error}
                                                    helperText={
                                                        txtTelefonoContactoPrincipal.required &&
                                                        txtTelefonoContactoPrincipal.error &&
                                                        txtTelefonoContactoPrincipal.helper
                                                    }
                                                    onChange={handleChangeDatosCompaniaUInt}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 20,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtCorreoContactoPrincipal.name}
                                                    label={txtCorreoContactoPrincipal.label}
                                                    required={txtCorreoContactoPrincipal.required}
                                                    value={txtCorreoContactoPrincipal.value}
                                                    error={txtCorreoContactoPrincipal.required && txtCorreoContactoPrincipal.error}
                                                    helperText={
                                                        txtCorreoContactoPrincipal.required &&
                                                        txtCorreoContactoPrincipal.error &&
                                                        txtCorreoContactoPrincipal.helper
                                                    }
                                                    onChange={handleChangeDatosCompaniaText}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 320,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtNumeroDUNS.name}
                                                    label={txtNumeroDUNS.label}
                                                    required={txtNumeroDUNS.required}
                                                    value={txtNumeroDUNS.value}
                                                    error={txtNumeroDUNS.required && txtNumeroDUNS.error}
                                                    helperText={txtNumeroDUNS.required && txtNumeroDUNS.error && txtNumeroDUNS.helper}
                                                    onChange={handleChangeDatosCompaniaUInt}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 9,
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Tooltip
                                                                    title="Sistema Universal de Numeración de Datos, identificador de nueve dígitos, identidad única de cada empresa a nivel internacional. Sistema desarrollado y regulado por Dun & BradStreet (D&B)."
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <IconButton>
                                                                        <InfoIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    className="input-upper"
                                                    name={txtRegistroPatronalIMSS.name}
                                                    label={txtRegistroPatronalIMSS.label}
                                                    required={txtRegistroPatronalIMSS.required}
                                                    value={txtRegistroPatronalIMSS.value}
                                                    error={txtRegistroPatronalIMSS.required && txtRegistroPatronalIMSS.error}
                                                    helperText={
                                                        txtRegistroPatronalIMSS.required &&
                                                        txtRegistroPatronalIMSS.error &&
                                                        txtRegistroPatronalIMSS.helper
                                                    }
                                                    onChange={handleChangeDatosCompaniaUpper}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 11,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtCartaPresentacion.name}
                                                    label={txtCartaPresentacion.label}
                                                    required={txtCartaPresentacion.required}
                                                    value={txtCartaPresentacion.value}
                                                    error={txtCartaPresentacion.required && txtCartaPresentacion.error}
                                                    helperText={
                                                        txtCartaPresentacion.required &&
                                                        txtCartaPresentacion.error &&
                                                        txtCartaPresentacion.helper
                                                    }
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 11,
                                                    }}
                                                    InputProps={{
                                                        readOnly: true,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {cartaPresentacionArhivo && (
                                                                    <IconButton onClick={handleClickEliminarArchivoCartaPresentacion}>
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                )}
                                                                <IconButton onClick={handleClickAdjuntarCartaPresentacion}>
                                                                    <AttachFileIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    name={txtSitioWeb.name}
                                                    label={txtSitioWeb.label}
                                                    required={txtSitioWeb.required}
                                                    value={txtSitioWeb.value}
                                                    error={txtSitioWeb.error}
                                                    helperText={txtSitioWeb.error && txtSitioWeb.helper}
                                                    onChange={handleChangeDatosCompaniaNotError}
                                                    variant={inputVariant}
                                                    color={inputColor}
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 300,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <div className="form-buttons">
                        <Button variant="contained" color="primary" onClick={handleClickConfirmarDatosCompania}>
                            Siguiente
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default DatosCompania;
